import styled from "styled-components";

const SpaceLayout = styled.div`
  width: ${(prop) => prop.width};
  height: ${(prop) => prop.height};
`;

function Space({ width = "0px", height = "0px" }) {
  return <SpaceLayout width={width} height={height} />;
}

export default Space;
